module.exports = __webpack_public_path__ + "static/media/administrator.5d9bc7be.svg";